import { render, staticRenderFns } from "./SubscribeChildrenForm.vue?vue&type=template&id=0a12f053"
import script from "./SubscribeChildrenForm.vue?vue&type=script&lang=js"
export * from "./SubscribeChildrenForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports